import { useMemo } from 'react';
import { useActiveAccount } from '@woonstad/msal-login';
import { useCustomRolesStore } from './useCustomRoles';

const ROLE_UUID_MAP = {
  '928d4d46-af47-4de0-b5c9-08edf222d088': 'ontwikkelaar',
  'df87386e-7ea1-4187-b279-1da5e8c21bc5': 'verhuurmakelaar',
  '73baeb8d-79f4-45d4-a7e6-00e998766cd5': 'inspecteur',
  '3cc47250-646c-47b3-a9da-e24fa1b44360': 'buurtbeheerder',
  '612c5baf-9184-453d-8929-70c75a18d530': 'aannemer',
  'zero': 'geen'
} as const;

export type Role = typeof ROLE_UUID_MAP[keyof typeof ROLE_UUID_MAP];

export const availableRoles: Role[] = Object.values(ROLE_UUID_MAP);
export const superUser: Role = 'ontwikkelaar';

export function useAzureRoles(): Role[] {
  const account = useActiveAccount();

  return useMemo(() => {
    const roleGroups = account?.idTokenClaims?.groups;
    if (!roleGroups || !Array.isArray(roleGroups)) return [];

    return roleGroups
      .map((roleGroup) => ROLE_UUID_MAP[roleGroup as keyof typeof ROLE_UUID_MAP])
      .filter((role): role is Role => role !== undefined);
  }, [account?.idTokenClaims?.groups]);
}

export function useUserRole(): Role[] {
  const customRoles = useCustomRolesStore(state => state.customRoles);
  const azureRoles = useAzureRoles();

  return useMemo(() => {
    if (customRoles && customRoles.length > 0) {
      return customRoles;
    }

    return azureRoles;
  }, [azureRoles, customRoles]);
}